/* Calendar export for maintenance reminders. */

function escapeICS(text) {
  return String(text || "")
    .replace(/\\/g, "\\\\")
    .replace(/;/g, "\\;")
    .replace(/,/g, "\\,")
    .replace(/\r?\n/g, "\\n");
}

export function downloadICS(title, date, notes) {
  const dt = new Date(date);
  const stamp = dt.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const dtDate = stamp.slice(0, 8);
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//SENOGARA//EN",
    "BEGIN:VEVENT",
    `UID:${Date.now()}@senogara`,
    `DTSTAMP:${stamp}`,
    `DTSTART;VALUE=DATE:${dtDate}`,
    `SUMMARY:${escapeICS(title)}`,
    `DESCRIPTION:${escapeICS(notes)}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ];
  const blob = new Blob([lines.join("\r\n")], { type: "text/calendar" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${title.replace(/\s+/g, "_")}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
